module.exports = __webpack_public_path__ + "static/media/md-today.411e8f5a.svg";